<template lang="html">
    <div>
        <template v-if="deleteItem == true">
            <p>Êtes-vous sûr de vouloir supprimer ce projet ?</p>
			<p><strong>{{ $store.state.single.data.label }}</strong></p>
        </template>
        <template v-else>
            <p>Ce projets est lié à un ou plusieurs produits, merci de le(s) supprimer afin de procéder à la suppression de ce projet</p>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                title:          'Supression d\'un projet',
                icon:           'delete',
                warning:        true,
                deleteItem: true
            }
        },

        methods: {
            onClose() {
                this.$eventHub.$emit('close-modal')
            },

            onValidate() {
                if(this.deleteItem == true) {
                    this.axios.delete(`/api/projects/${this.$store.state.single.data.id}`)
                        .then(response => {
                            this.$eventHub.$emit('close-modal')
                            this.$router.push({ name: 'projects' })
                        })
                        .catch(error => {
                            console.log(error.response.data || error)
                        })
                } else {
                    this.$eventHub.$emit('close-modal')
                }
            }
        },
        mounted(){
            this.axios.get(`/api/projects/${this.$store.state.single.data.id}?embed=sidamo_products,supplier_products,competitor_products`)
            .then(response => {
                if(response.data.supplier_products_count > 0 || response.data.sidamo_products_count > 0 || response.data.competitor_products_count > 0){
                    this.deleteItem = false
                }
            })
        }

    }
</script>

<style lang="stylus" scoped>
div {
    padding: 1rem 4rem;
}
</style>



// WEBPACK FOOTER //
// src/views/projects/single/Delete.vue